import { Divider } from '@mui/material'
import { FloatingMenuItem } from './FloatingMenuItem'
import styles from './index.module.scss'

/** @param {Parameters<typeof FloatingMenuItem>[0]['item'][]} items @param {Omit<Parameters<typeof FloatingMenuItem>[0], 'item'>} shared */
export function buildMenuEntries(items, shared) {
  return items.flatMap((item) => {
    const row = <FloatingMenuItem key={item.id} item={item} {...shared} />
    if (item.showDividerBefore) {
      return [
        <Divider key={`${item.id}-sep`} component="li" role="separator" className={styles.divider} />,
        row,
      ]
    }
    return [row]
  })
}
